import { useState } from "react";
import { Pressable, ScrollView, Text, View } from "react-native";
import type { ClinicianWorkbenchOutboundQuestionnaireCallV1 } from "@amplecare/contracts";
import type { AppShellTheme } from "../shell-core.js";

export function HybridReviewPanel({ messages, theme, fontFamily }: {
  messages: ClinicianWorkbenchOutboundQuestionnaireCallV1["automatedReviewMessages"];
  theme: AppShellTheme;
  fontFamily: string;
}) {
  const [open, setOpen] = useState(false);
  if (!messages?.length) return null;
  return (
    <View style={{ backgroundColor: theme.surface, borderColor: theme.borderSubtle, borderWidth: 1, borderRadius: 8, overflow: "hidden" }}>
      <Pressable accessibilityRole="button" accessibilityState={{ expanded: open }} aria-expanded={open} onPress={() => setOpen(value => !value)}>
        <Text style={{ color: theme.textPrimary, fontFamily, fontSize: 12, fontWeight: "700", padding: 10 }}>
          {open ? "Hide" : "Show"} questions &amp; automated review ({messages.length}) — review required
        </Text>
      </Pressable>
      {open ? (
        <ScrollView nestedScrollEnabled style={{ maxHeight: 360 }} contentContainerStyle={{ gap: 12, padding: 10 }}>
          <Text style={{ color: theme.textSecondary, fontFamily, fontSize: 12 }}>
            Recent messages and suggestions only. No automatic chart changes or clinical approval.
          </Text>
          {messages.map(message => (
            <View key={message.id} style={{ gap: 5 }}>
              <Text style={{ color: theme.textPrimary, fontFamily, fontSize: 12, fontWeight: "700" }}>{message.title}</Text>
              <Text selectable style={{ color: theme.textPrimary, fontFamily, fontSize: 12, lineHeight: 18 }}>{message.body}</Text>
            </View>
          ))}
        </ScrollView>
      ) : null}
    </View>
  );
}
